import { CtaEventDataType } from '@zola-helpers/client/dist/es';

export const mangeWebsiteCreateTrackingPayload = ({
  group_id,
  cta,
  cta_id,
  cta_type,
  position,
}: CtaEventDataType): CtaEventDataType => {
  return {
    business_unit: 'CORE',
    group_id,
    location: 'WEBSITE',
    section: 'MANAGE_WEBSITE',
    cta,
    cta_id,
    cta_type,
    position,
  };
};
